import { FadeIn } from '../../components/AnimateIn'
import Button from '../../components/Button'
import Section from '../../components/Section'
import { Text } from '../../components/Text'
import { WeBelieveBackground } from './WeBelieveBackground'

export default function WeBelieve() {
  return (
    <Section withVerticalPadding className='bg-white'>
      <div className='flex flex-col items-start justify-center lg:flex-row gap-[60px] lg:gap-[120px]'>
        <FadeIn className='w-full justify-center hidden lg:flex lg:flex-1'>
          <WeBelieveBackground />
        </FadeIn>
        <FadeIn className='flex flex-col gap-[44px] flex-1'>
          <Text.H2>We Believe</Text.H2>
          <Text.Body>
            We believe that the Bible—consisting of 39 books in the Old Testament and 27 in the New
            Testament—is the divinely inspired, verbally authoritative Word of God. We hold it to be
            inerrant, infallible, and historically accurate. We affirm the Bible as the sole
            authority in all matters of faith, doctrine, and practice.
          </Text.Body>
          <Text.Body>
            We believe in the unity of the Godhead and the Trinity of its persons—Father, Son, and
            Holy Spirit—each sovereign, co-equal, and co-eternal.
          </Text.Body>
          <div className='flex'>
            <Button variant='outline' href='/about' icon='ArrowRight' iconPosition='right'>
              Learn More
            </Button>
          </div>
        </FadeIn>
      </div>
    </Section>
  )
}
